export default {
  labels: {
    dont_have_account: 'Har du ikke en konto? ',
  },
  title: 'Bliv en del af {{name}}!',
  default_program_name: 'Belønningsklub',
  buttons: {
    sign_up: 'Tilmeld dig',
  },
};
